<script setup lang="ts">
import { toRefs } from 'vue';

interface Props {
  text: number;
  title: string;
  textColor: string;
}

const props = defineProps<Props>();

const { text, title, textColor } = toRefs(props);
</script>

<template>
  <div class="p-2 border-round bg-white justify-items-center seats-chip">
    <div class="text-color-gray text-xs text-center" v-text="title"></div>
    <div class="text-md font-bold text-center pt-1" :class="textColor" v-text="text" />
  </div>
</template>

<style scoped lang="scss">
.seats-chip {
  min-width: 90px;
}
</style>
